import { useEffect, useState } from "react";
import { getQueryParamsOrderForm } from "../../../services/order-add-edit-service";
import {
  getActiveButtonOrderFooter,
  shouldDisableHamburgerIcon,
  shouldEnableOrderButtonTableSystem,
  shouldEnablePaymentButtonTableSystem,
} from "../../../services/order-table-base-service";
import { Image } from "antd";
import { getOrCreateSessionId } from "../../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import { navToOrderEdit, navToPayment } from "../../../services/order-common-service";
import ActionModalWrapper from "./ActionModalWrapper";

export default function OrderFooterButtonsComponent({ context, orderStatus='', params, onHanleButtonActions }) {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const { isTableManagement, isTakeout, orderPageNo, sourcePage } = getQueryParamsOrderForm();
  const [activeButton, setActiveButton] = useState("");
  const [isEnabledPaymentButton, setIsEnabledPaymentButton] = useState(false);
  const [isDisableHamburger, setIsDiableHamburger] = useState(false);
  const [isEnabledOrderButton, setIsEnabledOrderButton] = useState();
  const [isOpenActionModal, setIsOpenActionModal] = useState(false);

  const onClickTableButton = () => {
    const sessionId = getOrCreateSessionId();
    navigate(`/table?session-id=${sessionId}`);
  };

  const onClickPaymentButton = () => {
    const takeout = isTakeout ? "Yes" : "No";
    navToPayment(navigate, orderId, "TABLE", takeout);
  };

  const onClickOrderButton = () => {
    const takeout = isTakeout ? "Yes" : "No";
    navToOrderEdit(navigate, orderId, sourcePage, takeout, orderPageNo);
  };

  useEffect(() => {
    const acButton = getActiveButtonOrderFooter();
    const paymentButtonState = shouldEnablePaymentButtonTableSystem();
    const hamburgerIconstate = shouldDisableHamburgerIcon(orderStatus);
    const orderButtonState = shouldEnableOrderButtonTableSystem(orderStatus);

    setActiveButton(acButton);
    setIsEnabledPaymentButton(paymentButtonState);
    setIsDiableHamburger(hamburgerIconstate);
    setIsEnabledOrderButton(orderButtonState);
  }, [orderStatus]);

  if (!isTableManagement) {
    return <></>;
  }

  return (
    <div>
      <div className="flex flex-col lg:flex-row items-center justify-end gap-4 mt-6">
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-end items-center gap-3 pr-4">
          <button
            disabled={isTakeout}
            className={`w-full sm:w-[154px] h-[42px] rounded-[5px] border border-[#E0E0E0] text-[14px] font-bold ${
              activeButton === "TABLE" ? "text-white bg-[#1BA09C]" : "text-black bg-[#FFFFFF]"
            }`}
            onClick={onClickTableButton}
          >
            Table
          </button>
          <button
            disabled={!isEnabledOrderButton}
            className={`w-full sm:w-[154px] h-[42px] rounded-[5px] border border-[#E0E0E0] text-[14px] font-bold ${
              activeButton === "ORDER" ? "text-white bg-[#1BA09C]" : "text-black bg-[#FFFFFF]"
            }`}
            onClick={onClickOrderButton}
          >
            Order
          </button>
          <button
            disabled={!isEnabledPaymentButton}
            className={`w-full sm:w-[154px] h-[42px] rounded-[5px] border border-[#E0E0E0] text-[14px] font-bold ${
              activeButton === "PAYMENT" ? "text-white bg-[#1BA09C]" : "text-black bg-[#FFFFFF]"
            } ${isEnabledPaymentButton ? "cursor-pointer" : "cursor-not-allowed"}`}
            onClick={onClickPaymentButton}
          >
            Payment
          </button>
          <button
            disabled={isDisableHamburger}
            className={`w-[45px] h-[25px] text-[14px] font-bold  ${
              isDisableHamburger ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            onClick={() => setIsOpenActionModal(true)}
          >
            <Image src="/images/icons/hamburger-icon.svg" preview={false} />
          </button>
        </div>
      </div>
      {orderId && 
      <ActionModalWrapper 
        open={isOpenActionModal}
        setIsOpenActionModal={() => setIsOpenActionModal(false)}
        isTakeout={isTakeout}
        />
      }
    </div>
  );
}
